/** @format */
import {
	showToast,
	showNotify,
	showFailToast,
	showSuccessToast,
	showLoadingToast,
	showDialog,
	showConfirmDialog,
	closeToast,
} from 'vant';

// //引入vant中函数式组件的样式
// // Toast
// import 'vant/es/toast/style';
// // Dialog
// import 'vant/es/dialog/style';
// // Notify
// import 'vant/es/notify/style';
// // ImagePreview
// import 'vant/es/image-preview/style';

export const PcMoModal = {
	// 消息提示
	msg(content) {
		showToast(content);
	},
	// 错误消息
	msgError(content) {
		showToast({
			message: content,
			icon: 'cross',
		});
	},
	// 成功消息
	msgSuccess(content) {
		showSuccessToast(content);
	},
	// 警告消息
	msgWarning(content) {
		showFailToast(content);
	},
	// 弹出提示
	alert(content) {
		showDialog({ title: '系统提示', message: content });
	},
	// 错误提示
	alertError(content) {
		showDialog({ title: '系统提示', message: content });
	},
	// 成功提示
	alertSuccess(content) {
		showDialog({ title: '系统提示', message: content });
	},
	// 警告提示
	alertWarning(content) {
		showDialog({ title: '系统提示', message: content });
	},
	// 通知提示
	notify(content) {
		showNotify({ type: 'primary', message: content });
	},
	// 错误通知
	notifyError(content) {
		showNotify({ type: 'danger', message: content });
	},
	// 成功通知
	notifySuccess(content) {
		showNotify({ type: 'success', message: content });
	},
	// 警告通知
	notifyWarning(content) {
		showNotify({ type: 'warning', message: content });
	},
	// 确认窗体
	confirm(content) {
		return showConfirmDialog({
			title: '系统提示',
			message: content,
		});
	},
	// 提交内容
	prompt(content) {
		return showConfirmDialog({
			title: '系统提示',
			message: content,
		});
	},
	// 打开遮罩层
	loading(content) {
		showLoadingToast({
			message: content,
			forbidClick: true,
			duration: 0,
		});
	},
	// 关闭遮罩层
	closeLoading() {
		closeToast();
	},
};
